<template>
  <div class="white-rounded-box pl-7 pt-7 posts-wrapper">
    <div class="flex justify-between items-center mr-9 mb-11">
      <h2 v-if="data.is_notification">Ping from notification</h2>
      <h2 v-else>The Current</h2>
      <div v-if="!data.is_notification" class="w-3/5">
        <label for="ping-search" class="sr-only">Search</label>
        <div class="">
          <form @submit.prevent="handleSearch">
            <input
              id="ping-search"
              name="ping-search"
              class="block w-full py-2 pr-3 br-10 text-hint placeholder-grey-600 focus:text-gray-900 focus:placeholder-gray-500 border-custom-grey shadow-custom-grey"
              placeholder="Search for a ping"
              type="search"
              v-model.lazy="search"
            />
            <button
              type="submit"
              title="Search"
              class="inset-y-0 right-0 pl-3 items-center float-right mt-n-10"
            >
              <svg-vue
                icon="search"
                title="Search"
                class="w-6 h-6 inline-block mr-3"
              />
            </button>
          </form>
        </div>
      </div>
    </div>

    <div class="all-posts-container">
      <template v-for="(post, i) in posts">
        <!-- OrgRequestPost -->
        <Post
          v-if="isOrgRequestPost(post)"
          :post="post"
          :key="i"
          :includeComments="
            post.mentions[0] ? post.mentions[0].pivot.ping_type == 0 : true
          "
          :isOrgInvite="
            post.mentions[0] && post.mentions[0].pivot.ping_type == 5
          "
          :isLast="i == posts.length - 1"
          :isOrgRequest="true"
          v-on:reachedEnd="handleScroll"
          v-on:openPingModal="replyToPing"
          v-on:tagClicked="tagClicked"
          :user="user"
        />
        <Post
          v-else
          :post="post"
          :key="i + posts.length"
          :includeComments="
            post.mentions[0] ? post.mentions[0].pivot.ping_type == 0 : true
          "
          :isLast="i == posts.length - 1"
          :isConnectionRequest="
            post.mentions[0] ? post.mentions[0].pivot.ping_type != 0 : false
          "
          v-on:reachedEnd="handleScroll"
          v-on:openPingModal="replyToPing"
          v-on:tagClicked="tagClicked"
          :user="user"
        />
      </template>
      <div
        v-if="isLoading"
        style="border-top-color: transparent"
        class="w-8 h-8 border-4 mx-auto my-5 border-blue-400 border-solid rounded-full animate-spin"
      ></div>
      <div
        v-if="isSearching && !isLoading && !posts.length"
        class="mx-auto my-5"
      >
        No Results found for this search.
      </div>
    </div>
  </div>
</template>

<script>
import Post from "../../Utils/Post.vue";
export default {
  // TODO: dynamically display post data
  data() {
    return {
      search: "",
      isSearching: false,
      paginationData: null,
      isLoading: false,
      posts: [],
    };
  },
  props: ["data", "activeTags", "user"],
  methods: {
    getMorePosts() {
      if (this.paginationData.next_page_url) {
        this.isLoading = true;
        axios
          .get(this.paginationData.next_page_url)
          .then((response) => {
            this.posts = [...this.posts, ...response.data.data];
            this.paginationData = response.data;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            console.log(error);
          });
      }
    },
    handleScroll(event) {
      if (!this.isSearching) {
        this.getMorePosts();
      }
    },
    replyToPing(user, parentId) {
      this.$emit("openPingModal", user, parentId);
    },
    getSearchResults() {
      axios
        .post("api/pings/search", {
          search_text: this.search,
        })
        .then((response) => {
//            console.log( response.data);
            if( !response.data){
//                console.log( 'no data');
                this.posts = [];
                this.isLoading = false;
            } else {
                this.isLoading = false;
                this.posts = response.data.data;
            }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
        });
    },
    handleSearch() {
      if (this.search != "") {
        this.isLoading = true;
        this.isSearching = true;
        this.getSearchResults();
      } else {
        this.isSearching = false;
        this.posts = this.data.data;
      }
    },
    tagClicked(tag) {
      this.$emit("tagClicked", tag);
    },
    isOrgRequestPost(post) {
      if (!post.mentions[0]) {
        return false;
      }
      return (
        post.mentions[0].pivot.ping_type == 3 ||
        post.mentions[0].pivot.ping_type == 4 ||
        post.mentions[0].pivot.ping_type == 5 ||
        post.mentions[0].pivot.ping_type == 6
      );
    },
  },
  components: {
    Post,
  },
  mounted() {
    this.posts = this.data.data;
    this.paginationData = this.data;
  },
  watch: {
    data() {
      this.posts = this.data.data;
    },
    search() {
      if (this.search != "") {
        this.isLoading = true;
        this.isSearching = true;
        this.getSearchResults();
      } else {
        this.isSearching = false;
        this.posts = this.data.data;
      }
    },
    activeTags() {
      if (this.activeTags) {
        this.search = "";
        this.activeTags.forEach((tag) => (this.search += tag + " "));
      }
    },
  },
};
</script>

<style scoped>
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  border-radius: 10px;
}

::-webkit-scrollbar-track {
  width: 10px;
  border-radius: 10px;
}
</style>
